import Box from '@mui/material/Box';
import { Form } from 'components/@shared/Form/Form';
import Stack from '@mui/material/Stack';
import { FormTextField } from 'components/@shared/Form/TextField';
import { FormPatternTextField } from 'components/@shared/Form/FormPatternTextField';
import { GoBackButton } from 'components/@shared/GoBackButton';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { FormGoogleAutocomplete } from 'components/@shared/Form/FormGoogleAutocomplete';
import { FormDateTimePicker } from 'components/@shared/Form/FormDateTimePicker';
import { AppointmentAttachmentSection } from 'components/Appointments/CreateAppointmentForm/Attachments';
import { HomePageFormData } from 'types/home-page';
import { validationSchema } from './validation';
import { initialValues } from './constants';

interface Props {
    initialData?: HomePageFormData;
    onCreate: (values: HomePageFormData) => void;
}

export const CreateHomePageForm = ({ initialData = initialValues, onCreate }: Props) => {
    return (
        <Form initialValues={initialData} validationSchema={validationSchema} onSubmit={onCreate}>
            <Stack gap={2} pt={3} pb={3} maxWidth={1000} mx="auto">
                <FormTextField name="description" label="Description" fullWidth size="small" multiline rows={4} />
                <Divider />
                <AppointmentAttachmentSection />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                    <GoBackButton />
                    <Button variant="contained" type="submit">
                        Save
                    </Button>
                </Box>
            </Stack>
        </Form>
    );
};
